import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import propTypes from 'prop-types';
import * as apps from '../../enums/apps';
import * as I18n from '../../lib/hoc';
import { hasAnyTruthy } from './selectors';

import './index.scss';

const ButtonMessages = ({ count, handleMouseEnter, toggle, isOpen, i18n, className }) => {
    const isUnread = hasAnyTruthy(count);
    const unreadClass = classNames('button-messages tbody-5 text-semi-bold', className, {
        unread: isUnread,
        'is-open': isOpen,
    });

    return (
        <button className={unreadClass} onMouseEnter={handleMouseEnter} onClick={toggle}>
            {i18n.t('realtime_notifications.notifications_drawer.messages')}
        </button>
    );
};

ButtonMessages.propTypes = {
    handleMouseEnter: propTypes.func,
    toggle: propTypes.func,
    count: propTypes.shape({
        [apps.APP_NAME_INBOX]: propTypes.number,
        [apps.APP_NAME_NOTIFICATIONS]: propTypes.number,
    }),
    i18n: propTypes.shape({
        t: propTypes.func,
    }),
    isOpen: propTypes.bool,
    className: propTypes.string,
};

export default compose(
    I18n.connect,
    connect(({ count }) => ({ count }))
)(ButtonMessages);
